module.exports = __webpack_public_path__ + "static/media/10.d5c77817.jpg";